import { createContext } from 'react';

const IntegrationContext = createContext();

export default IntegrationContext;
